<div class="tw-flex tw-flex-col tw-h-full tw-bg-teal-200 tw-bg-repeat-x tw-bg-top">
  @if (changeLanguage) {
    <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-[12px] tw-h-10 tw-w-10"
         (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
               [iconName]="'arrow_back'"></cs-icon>
    </div>
  }
  <div class="tw-px-6 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-h-[30%]">
    <img class="tw-block tw-w-[75px] tw-h-[25px]"
         src="/assets/icons/cs-logo.svg"
         alt="icon" />
    <div class="tw-w-60 tw-font-lexend tw-font-bold tw-text-800 tw-text-center tw-leading-10 tw-text-gray-800">
      {{ changeLanguage
      ? languageStrings.CHANGE_LANGUAGE[language.code]
      : languageStrings.CHOOSE_LANGUAGE[language.code]}}
    </div>
  </div>
  <div class="tw-flex-1 tw-p-6 tw-bg-white tw-rounded-tr-5 tw-rounded-tl-5">
    <div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-w-full anim-group">
      @for ( item of languages; track $index) {
        <div id="language-holder"
             class="tw-h-18 tw-px-4 tw-bg-gray-80 anim-fadeIn tw-rounded-2.5 tw-flex tw-items-center tw-shadow-[0px_2px_4px_0px_#0000001A]"
             (click)="selectLanguage(item)">
          <div class="tw-font-body tw-font-semibold tw-text-gray-800 tw-text-400"
               [class]=" { 'tw-animate-anim_click': language.code === item.code } ">
            {{item.displayName}}
          </div>
        </div>
      }
    </div>
  </div>
</div>
